import styled from "styled-components";
import theme from "~/styles/theme";

export const Card = styled.div`
  position: sticky;
  cursor: pointer;
  background-color: ${theme.palette.brand.primary.key};
  padding: 22px 16px 42px 22px;
  margin: 0 16px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 32px;
    max-height: 190px;
    margin: 0;
    max-width: 496px;
  }

  svg {
    margin-bottom: 8px;
    @media (min-width: ${theme.breakpoints.values.md}px) {
      margin-bottom: 32px;
    }
  }

  h6 {
    color: ${theme.palette.neutral.primary.light};
    margin-bottom: 8px;
  }

  span {
    color: ${theme.palette.neutral.primary.light};
    font-family: ${theme.typography.fontFamilyRegular};
  }
`;

export const MarginCards = styled.div`
  margin-top: -266px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin-top: -96px;
    margin-bottom: 72px;
  }
`;

export const Link = styled.div`
  display: flex;

  svg {
    margin-left: 9px;
  }
`;